import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { format } from 'date-fns';

import { dominioDemandaCirurgica } from '../../../config/database';

export default function TotalDemandasPedidosCirurgiasIncluidos(props) {
  const [dataInicioGrafico, setDataInicioGrafico] = useState('-');
  const [dataFimGrafico, setDataFimGrafico] = useState('-');
  const [config, setConfig] = useState({
    series: [
      {
        name: 'Pedidos finalizados',
        type: 'column',
        data: [],
      },
      {
        name: 'Demandas cadastradas',
        type: 'area',
        data: [],
      },
    ],
    options: {
      chart: {
        height: 350,
        width: '100%',
        type: 'line',
        stacked: false,
      },
      stroke: {
        width: [0, 2, 5],
        curve: 'smooth',
      },
      plotOptions: {
        bar: {
          columnWidth: '50%',
        },
      },

      title: {
        text: `Total de demandas e pedidos de cirurgia incluídos de ${dataInicioGrafico} e ${dataFimGrafico}`,
        offsetX: 0,
        align: 'center',
        style: {
          fontSize: '20px',
          fontWeight: 'bold',
        },
        floating: false,
      },

      responsive: [
        {
          breakpoint: 450,
          options: {
            title: {
              style: {
                fontSize: '8px',
              },
            },
          },
        },

        {
          breakpoint: 768,
          options: {
            title: {
              style: {
                fontSize: '15px',
              },
            },
          },
        },
      ],

      fill: {
        opacity: [0.85, 0.25, 1],
        gradient: {
          inverseColors: false,
          shade: 'light',
          type: 'vertical',
          opacityFrom: 0.85,
          opacityTo: 0.55,
          stops: [0, 100, 100, 100],
        },
      },
      labels: [],
      markers: {
        size: 4,
        fillOpacity: 0,
        strokeColor: '#fff',
        strokeWidth: 2,
        hover: {
          size: 7,
        },
      },
      xaxis: {
        type: 'datetime',
        enabled: true,
      },
      yaxis: {
        enabled: true,
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter(y) {
            if (typeof y !== 'undefined') {
              return `${y.toFixed(0)}`;
            }
            return y;
          },
        },
      },
    },
  });

  const { equipes, centrosCirurgicos, dataInicio, dataFim } = props;

  async function chartDemandaPedidoIncluido() {
    const dados = {
      filtros: {
        dataInicio: new Date(dataInicio),
        dataFim: new Date(dataFim),
      },
    };

    try {
      const responsePedido = await dominioDemandaCirurgica
        .post(`/api/listarTotalPedido`, dados)
        .then(response => {
          return response.data;
        });

      const responsePedidoTratado = responsePedido.map(item => {
        return item.totalPedidoHoje;
      });

      const responsePedidoDataInclusao = responsePedido.map(item => {
        return item.dataInclusao;
      });

      const dias = responsePedidoDataInclusao.map(item => {
        return format(new Date(item), 'dd/MM/yyyy');
      });

      const responseDemanda = await dominioDemandaCirurgica
        .post(`/api/listarTotalDemanda`, dados)
        .then(response => {
          return response.data;
        });

      const responseDemandaTratada = responseDemanda.map(item => {
        return item.totaldemandaacumulada;
      });

      const configChart = {
        series: [
          {
            name: 'Pedidos finalizados',
            type: 'column',
            data: [],
          },
          {
            name: 'Demandas cadastradas',
            type: 'area',
            data: [],
          },
        ],
        options: {
          chart: {
            height: 350,
            width: '100%',
            type: 'line',
            stacked: false,
          },
          stroke: {
            width: [0, 2, 5],
            curve: 'smooth',
          },
          plotOptions: {
            bar: {
              columnWidth: '50%',
            },
          },

          title: {
            text: `Total de demandas e pedidos de cirurgia incluídos de  ${dataInicioGrafico} a ${dataFimGrafico}`,
            offsetX: 0,
            align: 'center',
            style: {
              fontSize: '20px',
              fontWeight: 'bold',
            },
            floating: false,
          },

          fill: {
            opacity: [0.85, 0.25, 1],
            gradient: {
              inverseColors: false,
              shade: 'light',
              type: 'vertical',
              opacityFrom: 0.85,
              opacityTo: 0.55,
              stops: [0, 100, 100, 100],
            },
          },
          labels: [],
          markers: {
            size: 4,
            fillOpacity: 0,
            strokeColor: '#fff',
            strokeWidth: 2,
            hover: {
              size: 7,
            },
          },
          xaxis: {
            type: 'category',
            enabled: true,
          },
          yaxis: {
            enabled: true,
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter(y) {
                if (typeof y !== 'undefined') {
                  return `${y.toFixed(0)}`;
                }
                return y;
              },
            },
          },
        },
      };

      configChart.series[0].data = responsePedidoTratado;
      configChart.series[1].data = responseDemandaTratada;
      configChart.options.labels = dias;

      setConfig(configChart);
    } catch (error) {
      console.log(error);
    }
  }

  const updateCharts = () => {
    const idsEquipes = equipes.map(equipe => {
      return equipe.id;
    });

    const idsCentrosCirurgicos = centrosCirurgicos.map(centroCirurgico => {
      return centroCirurgico.id;
    });

    const dados = {
      filtros: {
        equipes: idsEquipes?.length > 0 ? idsEquipes.join() : null,
        centrosCirurgicos: idsCentrosCirurgicos?.length > 0 ? idsCentrosCirurgicos.join() : null,
        dataInicio: new Date(dataInicio),
        dataFim: new Date(dataFim),
      },
    };

    /* dominioDemandaCirurgica.post(`/api/listarDemandasPedidosIncluidos`, dados).then(response => {
      const config = {
        series: [
          {
            name: 'Demandas cadastradas',
            type: 'column',
            data: [],
          },
          {
            name: 'Pedidos finalizados',
            type: 'area',
            data: [],
          },
        ],
        options: {
          chart: {
            height: 350,
            width: '100%',
            type: 'line',
            stacked: false,
          },
          stroke: {
            width: [0, 2, 5],
            curve: 'smooth',
          },
          plotOptions: {
            bar: {
              columnWidth: '50%',
            },
          },
   
          title: {
            text: `Total de demandas e pedidos de cirurgia incluídos de ${dataInicioGrafico} e ${dataFimGrafico}`,
            offsetX: 0,
            align: 'center',
            style: {
              fontSize: '20px',
              fontWeight: 'bold',
            },
            floating: false,
          },
   
          fill: {
            opacity: [0.85, 0.25, 1],
            gradient: {
              inverseColors: false,
              shade: 'light',
              type: 'vertical',
              opacityFrom: 0.85,
              opacityTo: 0.55,
              stops: [0, 100, 100, 100],
            },
          },
          labels: [],
          markers: {
            size: 4,
            fillOpacity: 0,
            strokeColor: '#fff',
            strokeWidth: 2,
            hover: {
              size: 7,
            },
          },
          xaxis: {
            type: 'category',
            enabled: true,
          },
          yaxis: {
            enabled: true,
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter(y) {
                if (typeof y !== 'undefined') {
                  return `${y.toFixed(0)}`;
                }
                return y;
              },
            },
          },
        },
      };
   
      const respostaTratada = response.data.filter(
        dado => dado.total_demanda > 0 || dado.total_pedido > 0
      );
   
      const demandasCadastradas = respostaTratada.map(dado => {
        return dado.total_demanda;
      });
      config.series[0].data = demandasCadastradas;
   
      const pedidosCadastrados = respostaTratada.map(dado => {
        return dado.total_pedido;
      });
      config.series[1].data = pedidosCadastrados;
   
      const dias = respostaTratada.map(dado => {
        return format(new Date(dado.data_ocorrido), 'dd/MM/yyyy');
      });
      config.options.labels = dias;
      setConfig(config);
    }); */
  };

  useEffect(() => {
    setDataInicioGrafico(format(new Date(dataInicio), 'dd/MM/yyyy'));
    setDataFimGrafico(format(new Date(dataFim), 'dd/MM/yyyy'));
  }, [dataInicio, dataFim]);

  useEffect(() => {
    chartDemandaPedidoIncluido();
  }, [dataInicio, dataFim, dataInicioGrafico, dataFimGrafico]);

  useEffect(() => {
    updateCharts();
  }, [equipes, centrosCirurgicos, dataInicio, dataFim, dataInicioGrafico, dataFimGrafico]);

  return (
    <>
      <Card style={{ width: '100%' }}>
        <CardContent>
          <Chart options={config.options} series={config.series} type="line" height={350} />
        </CardContent>
      </Card>
    </>
  );
}
